import ActionTypes from '@ziynx/action-types';

type NotificationAction = {
  type: string,
  payload: {
    content: string,
    variant: 'success' | 'error',
  }
}

const initialState = {};

export default function reduceNotification(state = initialState, action: NotificationAction) {
  if (!action?.type) {
    return state;
  }

  switch (action?.type) {
  case ActionTypes.notifications.add.SUCCESS:
    return {
      content: action?.payload?.content,
      variant: action?.payload?.variant,
    };

  case ActionTypes.notifications.remove:
  case ActionTypes.notifications.removeAll:
  case ActionTypes.notifications.add.START:
    return initialState;

  default:
    return state;
  }
}
